import { useEffect, useMemo, useState } from 'react';

import { useLazyQuery } from '@apollo/client';
import { PricingType } from '@prisma/client';
import { useField } from 'formik';
import { PartnerOffers } from 'types/graphql';

import { useQuery } from '@redwoodjs/web';

import { AssignToggle } from 'src/components';
import { GET_PARTNERS_OFFERS } from 'src/graphql/queries/partners.query';
import { GET_PRICING_OFFER } from 'src/graphql/queries/pricing.query';

import ViewPricingModal from '../../../../ViewTerminalPricingsPage/ViewPricingModal';
import OffersContainer from '../OffersContainer/OffersContainer';

const OnlineOffers = () => {
    const [selectedOffer, setSelectedOffer] = useState<PartnerOffers>();
    const [{ value: assignedOffers }, _, { setValue }] = useField('assignedOffers');
    const { data } = useQuery(GET_PARTNERS_OFFERS);

    const assigned = useMemo(() => {
        return (data?.partnersOffers || [])
            .filter(({ type }) => {
                return type === PricingType.ONLINE;
            })
            .map(({ id, name }) => {
                return {
                    value: id,
                    label: name,
                };
            })
            .filter(({ value }) => {
                return assignedOffers?.includes(value);
            });
    }, [data, assignedOffers]);

    const unassigned = useMemo(() => {
        return (data?.partnersOffers || [])
            .filter(({ type }) => {
                return type === PricingType.ONLINE;
            })
            .map(({ id, name }) => {
                return {
                    value: id,
                    label: name,
                };
            })
            .filter(({ value }) => {
                return !assignedOffers?.includes(value);
            });
    }, [data, assignedOffers]);

    const [modalOpen, setModalOpen] = useState(false);
    const [getPricingOffer, { data: pricingOfferData }] = useLazyQuery(GET_PRICING_OFFER);
    const handleViewOffer = (offerId) => {
        getPricingOffer({ variables: { id: offerId } });
    };
    useEffect(() => {
        if (pricingOfferData && pricingOfferData.offer) {
            setSelectedOffer(pricingOfferData.offer);
            setModalOpen(true);
        }
    }, [pricingOfferData]);

    return (
        <OffersContainer title="Online Offers">
            <AssignToggle
                assigned={assigned}
                unassigned={unassigned}
                assignedTitled="Assigned Offers"
                unassignedTitled="Available Offers"
                onAssign={(offerIds) => {
                    const previousOffers = assignedOffers || [];
                    setValue([
                        ...previousOffers,
                        ...offerIds.map(({ value }) => {
                            return value;
                        }),
                    ]);
                }}
                onUnassign={(offersToUnassign) => {
                    const previousOffers = assignedOffers || [];
                    const offerIds = offersToUnassign.map(({ value }) => {
                        return value;
                    });

                    setValue(
                        previousOffers.filter((el) => {
                            return !offerIds.includes(el);
                        })
                    );
                }}
                onView={(offerId: number) => {
                    handleViewOffer(offerId);
                }}
                containerProps={{ padding: '0px' }}
            />
            <ViewPricingModal
                open={modalOpen}
                handleCloseModal={() => {
                    return setModalOpen(false);
                }}
                offer={selectedOffer}
            />
        </OffersContainer>
    );
};

export default OnlineOffers;
